// Envío por tramos al carrito: recalcula el mensaje y la barra cada vez que cambia el carrito.
// Los tramos llegan del snippet mp-trams-enviament («hasta:coste» en céntimos, sin IVA);
// por encima del último límite el envío es gratis. Misma cuenta que free-shipping-bar.liquid.
(() => {
  if (window.customElements.get("mp-envio-trams")) return;

  const eur = (cents, decimals) =>
    new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: decimals,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  const importe = (cents) => eur(cents, 2); // 29,50 €
  const redondo = (cents) => eur(cents, cents % 100 === 0 ? 0 : 2); // 30 €

  class MpEnvioTrams extends HTMLElement {
    connectedCallback() {
      this.onCartChange = (event) => {
        const cart = event.detail && event.detail.cart;
        if (!cart) return;
        const items = cart.items
          .filter((item) => item.requires_shipping)
          .reduce((sum, item) => sum + item.final_line_price, 0);
        const discount = cart.cart_level_discount_applications.reduce(
          (sum, d) => sum + d.total_allocated_amount,
          0,
        );
        this.render(items - discount);
      };
      document.addEventListener("cart:change", this.onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener("cart:change", this.onCartChange);
    }

    render(total) {
      const grossPrimary = window.mpPriceMode === 'gross';
      const pct = +this.getAttribute('tax-pct') || 0;
      const display = cents => grossPrimary ? Math.round(cents * (100 + pct) / 100) : cents;
      const trams = this.getAttribute("trams")
        .split(",")
        .map((t) => t.split(":").map(Number));
      const freeFrom = trams[trams.length - 1][0] + 1;
      const i = trams.findIndex(([hasta]) => total <= hasta);
      const msg = this.querySelector("[data-msg]");
      if (i === -1) {
        msg.innerHTML = "<strong>Envío gratis</strong> a la península en este pedido.";
      } else {
        const [hasta, coste] = trams[i];
        const siguiente = trams[i + 1] ? trams[i + 1][1] : 0;
        const faltan = hasta + 1 - total;
        const cola = siguiente > 0
          ? `para ahorrarte ${redondo(display(coste) - display(siguiente))} de envío.`
          : "para que el envío te salga <strong>gratis</strong>.";
        msg.innerHTML = `Envío a península: <strong>${redondo(display(coste))} ${grossPrimary ? 'IVA incl.' : '+ IVA.'}</strong> Te faltan <strong>${importe(display(faltan))}</strong> ${cola}`;
      }
      const fill = this.querySelector("[data-fill]");
      if (fill) fill.style.width = `${Math.min(100, Math.floor((total * 100) / freeFrom))}%`;
      this.setAttribute("total-price", total);
    }
  }

  window.customElements.define("mp-envio-trams", MpEnvioTrams);
})();
